import React from 'react';
import { Target, Users, Sparkles } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen pt-28 pb-20 bg-[#F9F6F0] relative overflow-hidden">
      {/* Background drifting blobs */}
      <div className="bg-blob blob-gold top-[10%] left-[-5%] w-[400px] h-[400px] opacity-35" />
      <div className="bg-blob blob-saffron bottom-[15%] right-[-5%] w-[450px] h-[450px] opacity-40" />

      <div className="container mx-auto max-w-4xl px-6 md:px-12 relative z-10">
        
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[10px] font-bold tracking-widest uppercase text-[#D97706] mb-2 block">
            Who We Are
          </span>
          <h1 className="text-3xl md:text-5xl font-bold font-vedic text-[#352520] mb-4">
            About Vastuspace.AI
          </h1>
          <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed max-w-xl mx-auto">
            Bringing Ancient Wisdom to Modern Living Through Artificial Intelligence
          </p>
        </div>

        {/* 3 Core Stats Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {/* Mission */}
          <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 p-8 rounded-3xl text-center hover:shadow-md transition-all duration-300">
            <div className="w-12 h-12 rounded-2xl bg-[#FFF3E0] flex items-center justify-center mx-auto mb-5 text-[#D97706]">
              <Target className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-bold font-vedic text-[#352520] mb-2">Our Mission</h3>
            <p className="text-xs text-[#5D4E37] font-light leading-relaxed">
              Make Vastu analysis accessible, accurate, and affordable for everyone.
            </p>
          </div>

          {/* Technology */}
          <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 p-8 rounded-3xl text-center hover:shadow-md transition-all duration-300">
            <div className="w-12 h-12 rounded-2xl bg-[#FFF3E0] flex items-center justify-center mx-auto mb-5 text-[#D97706]">
              <Sparkles className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-bold font-vedic text-[#352520] mb-2">Our Technology</h3>
            <p className="text-xs text-[#5D4E37] font-light leading-relaxed">
              State-of-the-art AI trained on thousands of Vastu principles and floor plans.
            </p>
          </div>

          {/* Team */}
          <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 p-8 rounded-3xl text-center hover:shadow-md transition-all duration-300">
            <div className="w-12 h-12 rounded-2xl bg-[#FFF3E0] flex items-center justify-center mx-auto mb-5 text-[#D97706]">
              <Users className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-bold font-vedic text-[#352520] mb-2">Our Team</h3>
            <p className="text-xs text-[#5D4E37] font-light leading-relaxed">
              Expert Vastu consultants and AI engineers working together.
            </p>
          </div>
        </div>

        {/* Story Section */}
        <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 rounded-3xl p-8 md:p-12 mb-16 text-left shadow-sm">
          <h2 className="text-2xl font-bold font-vedic text-[#352520] mb-6">
            The Story Behind Vastuspace.AI
          </h2>
          <div className="space-y-4 text-sm text-[#5D4E37] font-light leading-relaxed">
            <p>
              Vastuspace.AI was founded by <strong>Yash</strong>, an architect who experienced firsthand the
              challenges of integrating traditional Vastu principles into modern architectural projects.
              After consulting with multiple Vastu experts for each project, he realized the need for a
              faster, more accessible solution.
            </p>
            <p>
              By combining ancient Vastu Shastra wisdom with cutting-edge artificial intelligence, Vastuspace.AI
              makes expert-level Vastu analysis available instantly. Our AI has been trained on thousands
              of traditional Vastu principles, validated by certified Vastu consultants.
            </p>
            <p>
              Today, Vastuspace.AI serves homeowners, architects, and real estate developers across India,
              helping them create harmonious living and working spaces aligned with Vastu principles.
            </p>
          </div>
        </div>

        {/* Vision section (Light Orange Bordered Card) */}
        <div className="bg-[#FFF8F2] border-2 border-[#D97706] rounded-3xl p-10 md:p-12 text-center shadow-lg relative overflow-hidden mb-16">
          <div className="absolute inset-0 bg-radial-gradient from-[#D97706]/10 to-transparent opacity-10 pointer-events-none" />
          <h2 className="text-2xl md:text-3xl font-bold font-vedic text-[#352520] mb-4 relative z-10">Our Vision</h2>
          <p className="text-sm md:text-base text-[#5D4E37] leading-relaxed font-light max-w-2xl mx-auto relative z-10">
            To become the world's most trusted platform for Vastu analysis, combining traditional wisdom
            with modern technology to create spaces that promote health, prosperity, and well-being.
          </p>
        </div>

        {/* Advisory Team */}
        <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 rounded-3xl p-8 md:p-12 text-center shadow-sm">
          <h2 className="text-2xl font-bold font-vedic text-[#352520] mb-4">
            Advisory & Consultation Team
          </h2>
          <p className="text-sm text-[#5D4E37] font-light leading-relaxed max-w-xl mx-auto">
            Vastuspace.AI is backed by a team of certified Vastu consultants and technology experts who ensure
            accuracy and authenticity in every analysis.
          </p>
        </div>

      </div>
    </div>
  );
};

export default About;
